import axios from 'axios';

// Determine API base URL based on environment
const API_BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api/mailvotes`
  : (process.env.NODE_ENV === 'development'
    ? 'http://localhost:5005/api/mailvotes'
    : 'https://doorknockserver-280072100489.us-central1.run.app/api/mailvotes');

console.log('[VoterService] Using API_BASE:', API_BASE);
console.log('[VoterService] Environment:', process.env.NODE_ENV);
console.log('[VoterService] REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

// Create NEW axios instance (avoid any cached instances)
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to log all requests
api.interceptors.request.use(
  (config) => {
    console.log('[API Request]', config.method.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  }
);

// Voter data service
const voterService = {
  // Get list of counties
  getCounties: async () => {
    try {
      const response = await api.get('/counties');
      return response.data;
    } catch (error) {
      console.error('Error fetching counties:', error);
      throw error;
    }
  },

  // Get counties for a specific state
  getCountiesByState: async (state) => {
    try {
      const response = await api.get(`/counties/${state}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching counties by state:', error);
      throw error;
    }
  },

  // Get cities for a specific state and county
  getCities: async (state, county) => {
    try {
      const response = await api.get(`/cities/${state}/${encodeURIComponent(county)}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching cities:', error);
      throw error;
    }
  },

  // Get list of elections
  getElections: async () => {
    try {
      const response = await api.get('/elections');
      return response.data;
    } catch (error) {
      console.error('Error fetching elections:', error);
      throw error;
    }
  },

  // Search voters based on filters
  searchVoters: async (filters) => {
    try {
      const response = await api.post('/search', filters, {
        timeout: 300000 // 5 minute timeout for large queries
      });
      return response.data;
    } catch (error) {
      console.error('Error searching voters:', error);
      throw error;
    }
  },

  // (The unauthenticated /download export was removed server-side. Paid
  // lists come from /api/mailvotes/downloads/create-link after checkout.)

  // Get voter count based on filters
  getVoterCount: async (filters) => {
    try {
      const response = await api.post('/count', filters, {
        timeout: 300000 // 5 minute timeout
      });
      return response.data;
    } catch (error) {
      console.error('Error getting voter count:', error);
      throw error;
    }
  },

  // Get state-specific voter count
  getStateCount: async (filters) => {
    try {
      const response = await api.post('/count', filters, {
        timeout: 300000 // 5 minute timeout
      });
      return response.data;
    } catch (error) {
      console.error('Error getting state voter count:', error);
      throw error;
    }
  },

  // Get available states
  getStates: async () => {
    try {
      const response = await api.get('/states');
      return response.data;
    } catch (error) {
      console.error('Error fetching states:', error);
      throw error;
    }
  },

  // Get filters for a specific state
  getStateFilters: async (state) => {
    try {
      const response = await api.get(`/filters/${state}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching state filters:', error);
      throw error;
    }
  },

  // Search state-specific voters
  searchStateVoters: async (state, filters) => {
    try {
      const response = await api.post('/state', {
        state,
        ...filters
      });
      return response.data;
    } catch (error) {
      console.error('Error searching state voters:', error);
      throw error;
    }
  }
};

export default voterService;